import { InternalUser } from '../../../../projects/tilled-api-client/src';

export class UserRoles {
  static DisplayText = new Map<InternalUser.RoleEnum, string>([
    [InternalUser.RoleEnum.ADMIN, 'Admin'],
    [InternalUser.RoleEnum.ANALYST, 'Analyst'],
    [InternalUser.RoleEnum.DEVELOPER, 'Developer'],
    [InternalUser.RoleEnum.OWNER, 'Owner'],
    [InternalUser.RoleEnum.VIEW_ONLY, 'View Only'],
    [InternalUser.RoleEnum.ACCOUNT_MANAGER, 'Account Manager'],
    [InternalUser.RoleEnum.ONBOARDING_SALES_REP, 'Sales Representative'],
    [InternalUser.RoleEnum.RESTRICTED_VIEW_ONLY, 'Restricted View-only'],
    [InternalUser.RoleEnum.MERCHANT_OWNER, 'Merchant Owner'],
    [InternalUser.RoleEnum.MERCHANT_ADMIN, 'Merchant Admin'],
    [InternalUser.RoleEnum.MERCHANT_VIEW_ONLY, 'Merchant View-only'],
    [InternalUser.RoleEnum.RESELLER_OWNER, 'Owner'],
    [InternalUser.RoleEnum.RESELLER_ADMIN, 'Admin'],
    [InternalUser.RoleEnum.RESELLER_INTEGRATION_ANALYST, 'Integration Analyst'],
    [InternalUser.RoleEnum.RESELLER_SALES_REP, 'Sales Representative'],
    [InternalUser.RoleEnum.RESELLER_SUPPORT_SPECIALIST, 'Support Specialist'],
    [InternalUser.RoleEnum.RESELLER_VIEW_ONLY, 'View-only'],
  ]);

  static Description = new Map<InternalUser.RoleEnum, string>([
    [
      InternalUser.RoleEnum.ADMIN,
      'Admins can view and manage everything across accounts, payments, reports, developer tools, and user permissions. Admin users also have access to commission statements.',
    ],
    [
      InternalUser.RoleEnum.ANALYST,
      'Analysts can view everything and update key data across payments, disputes, CSV reports, and account settings — but cannot make changes to developer tools or invite users.',
    ],
    [
      InternalUser.RoleEnum.DEVELOPER,
      'Developers can read and manage API keys and webhook endpoints, and view all merchant and reporting data. ' +
        'Developer users cannot update merchant profiles or account settings.',
    ],
    [
      InternalUser.RoleEnum.VIEW_ONLY,
      'This role grants read-only access to all areas, without the ability to make any changes.',
    ],
    [
      InternalUser.RoleEnum.ACCOUNT_MANAGER,
      'Account managers have view-only access to merchant and reporting data — including account details, disputes, and pricing templates. ' +
        'They cannot view or modify merchant applications, developer tools, users, or merchant preferences.',
    ],
    [
      InternalUser.RoleEnum.MERCHANT_ADMIN,
      'Admins can view and manage everything across payments, disputes, and account settings.',
    ],
    [
      InternalUser.RoleEnum.MERCHANT_VIEW_ONLY,
      'This role grants read-only access to all areas, without the ability to make any changes.',
    ],
    [
      InternalUser.RoleEnum.ONBOARDING_SALES_REP,
      'This role is for users who only need basic access to the merchants page.',
    ],
    [InternalUser.RoleEnum.RESTRICTED_VIEW_ONLY, 'This role is for users who need restricted view-only access.'],
    [
      InternalUser.RoleEnum.RESELLER_ADMIN,
      'Admins can view and manage everything across accounts, payments, reports, developer tools, and user permissions. Admin users also have access to commission statements.',
    ],
    [
      InternalUser.RoleEnum.RESELLER_INTEGRATION_ANALYST,
      'Integration analysts have read-only access to most data, allowing them to assist with setup, troubleshoot issues, and monitor account activity without making changes.',
    ],
    [
      InternalUser.RoleEnum.RESELLER_SALES_REP,
      'This role allows users to create and update merchant accounts, pricing, and applications. They can also view processing activity, reports, and account details.',
    ],
    [
      InternalUser.RoleEnum.RESELLER_SUPPORT_SPECIALIST,
      'Support specialists can view all information and manage common merchant tasks like updating account details, processing refunds, and handling disputes.',
    ],
    [
      InternalUser.RoleEnum.RESELLER_VIEW_ONLY,
      'This role grants read-only access to all areas, without the ability to make any changes.',
    ],
  ]);
}
